import Typography from './typography';
import createTitle from './create-title';
import './styles/index.scss';
const ExpandedTypography = Typography;
ExpandedTypography.H1 = createTitle('h1');
ExpandedTypography.H2 = createTitle('h2');
ExpandedTypography.H3 = createTitle('h3');
ExpandedTypography.H4 = createTitle('h4');
ExpandedTypography.H5 = createTitle('h5');
ExpandedTypography.H6 = createTitle('h6');
ExpandedTypography.Text = Typography;
export default ExpandedTypography;
